<script>
  import RemoteImage from "./ImageComponentVariants/RemoteImage.svelte";
  import {s3linkfrom} from "../AppState/EndpointsAndTransforms";

  export let storyframeData

  let currentlyFocusedImageName = s3linkfrom(storyframeData['mediaURLs'][0])
</script>

<main>
  {#if storyframeData['tagline'] != null}
    <tagline><h2>{storyframeData['tagline']}</h2></tagline>
  {/if}

  <media>
    {#each storyframeData['mediaURLs'] as name}
      <img src={s3linkfrom(name)} on:click="{() => {
        currentlyFocusedImageName = s3linkfrom(name)
      }}" />
    {/each}
  </media>

  {#if currentlyFocusedImageName != null}
    <focused>
      <img src={currentlyFocusedImageName}/>
    </focused>
  {/if}

  {#if storyframeData['storyText'] != null}
    <storyText><h3>{storyframeData['storyText']}</h3></storyText>
  {/if}
</main>

<style>
  media {
    grid-area: media;
    width: 100%;
    height: 100%;
    max-width: 100%;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    align-items: flex-start;
    place-items: flex-start;
  }

  media img {
    width: 47%;
    height: auto;
    max-height: 30%;
    margin: 2px;
    object-fit: contain;
  }

  media img:hover {
    padding: 2px;
    filter: drop-shadow(0px 0px 5px orange);
  }

  focused {
    grid-area: focused;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  focused img {
    width: 100%;
    max-width: 100%;
    object-fit: contain;
    height: auto;
    max-height: 90%;
    filter: drop-shadow(0px 2px 7px #88c3ea);
    margin: 5px;
  }

  main {
    display: grid;
    grid-template-columns: 60% 3% 33%;
    grid-template-rows: minmax(100px, 340px) 1fr;
    grid-template-areas:
    "tagline storyText storyText"
    "focused . media"
  ;

    height: 100%;
    width: 100%;
    justify-items: stretch;
    align-items: stretch;
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 2px;
    padding-right: 2px;
  }

  tagline {
    grid-area: tagline;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }
  storyText {
    grid-area: storyText;
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }

  h2 {
    color: white;
    line-height: 2;
    margin: 12px;
    text-align: left;
    padding: 15px;
  }

  h3 {
    color: white;
    line-height: 2;
    margin: 12px;
    text-align: right;
    padding: 15px;
  }
</style>